import { cabinetDisplayName } from "@/lib/wording";
import { useState, useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AppSidebar } from "@/components/AppSidebar";
import { Logo } from "@/components/Logo";
import { List } from "@phosphor-icons/react";
import { toast } from "sonner";
import { ImpersonationBanner } from "@/components/ImpersonationBanner";

export default function AppShell() {
  const navigate = useNavigate();
  const location = useLocation();
  const { cabinet } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [convos, setConvos] = useState([]);
  const brand = cabinetDisplayName(cabinet);

  useEffect(() => { api.get("/agent/conversations").then((r) => setConvos(r.data)).catch(() => {}); }, []);
  // Ferme le drawer mobile à chaque changement de page (le shell ne se démonte pas entre sous-pages)
  useEffect(() => { setMobileOpen(false); }, [location.pathname]);


  return (
    <div className="h-full flex bg-background text-foreground overflow-hidden">
      <AppSidebar
        showConversations
        convos={convos}
        mobileOpen={mobileOpen}
        onCloseMobile={() => setMobileOpen(false)}
        onNewConvo={() => navigate("/app")}
        onOpenConvo={(id) => navigate(`/app?c=${id}`)}
        onRemoveConvo={async (id, e) => {
          e.stopPropagation();
          try { await api.delete(`/agent/conversations/${id}`); setConvos((c) => c.filter((x) => x.id !== id)); }
          catch { toast.error("Suppression impossible"); }
        }}
        onOpenSkills={() => navigate("/app?skills=1")}
        onOpenRevisions={() => navigate("/app?revisions=1")}
        onOpenJournal={() => navigate("/app?journal=1")}
      />
      <div className="flex-1 flex flex-col min-w-0 relative">
        <ImpersonationBanner />
        <header className="md:hidden flex items-center gap-3 px-4 py-3 border-b border-border">
          <button onClick={() => setMobileOpen(true)} data-testid="sidebar-toggle" className="h-9 w-9 rounded-md flex items-center justify-center hover:bg-muted"><List size={20} /></button>
          <Logo className="h-6 w-6" />
          <span className="font-heading font-bold truncate">{brand}</span>
        </header>
        <div className="flex-1 overflow-y-auto">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
